import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_57353298";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_57353298" };
/** script content **/
require("./picker-popup.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex57353298%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpicker-popup%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_57353298"],
    ctorType: "component",
    outputPath: "components/index57353298/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-popup-base': getComponent(require("./picker-popup-base.mpx?isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex")), 'cube-picker': getComponent(require("../picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
